import React from "react";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import { FaFile } from "react-icons/fa";
// import DeleteAsyncJobModal from "../../../../components/delete-async-job-modal/DeleteAsyncJobModal";
import { Button } from "reactstrap";
import { FiDownload } from "react-icons/fi";
// import { HiOutlineTrash } from "react-icons/hi";
import "./asyncJobsRow.css";
import useRoles from "../../../../../../components/hooks/useRoles";

const AsyncJobRow = ({ entry, handleDelete, downloadFile, isExport }) => {
  // const [isOpenDelete, setIsOpenDelete] = useState(false);
  // const toggleDelete = () => {
  //   setIsOpenDelete(!isOpenDelete);
  // };
  const { isClient } = useRoles();

  var saveData = (function () {
    var a = document.createElement("a");
    // document.body.appendChild(a);
    // a.style = "display: none";
    return function (data, fileName) {
      var blob = new Blob([data], { type: "octet/stream" }),
        url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    };
  })();

  const resultMessage = (resultMessage) => {
    saveData(resultMessage, "result-message.txt");
  };

  function RenderAction() {
    if (isClient) {
      return (
        <div>
          <ReactTooltip id="download-icon" type="error">
            <span>No Access</span>
          </ReactTooltip>
          <FiDownload
            size="1.6em"
            data-tip
            data-for="download-icon"
            color="#0088E4"
          />
        </div>
      );
    }
    return (
      <div>
        <ReactTooltip id="download-icon" type="success">
          <span>Download</span>
        </ReactTooltip>
        <FiDownload
          size="1.6em"
          data-tip
          data-for="download-icon"
          color="#0088E4"
          onClick={() => {
            downloadFile(entry.id);
          }}
        />
      </div>
    );
  }

  return (
    <React.Fragment>
      <tr>
        <td>
          {moment.utc(entry.createDate).local().format("DD.MM.YYYY HH:mm:ss")}
        </td>
        <td>{entry.type}</td>
        <td>{entry.createdBy}</td>
        <td>
          {entry.startDate != null
            ? moment.utc(entry.startDate).local().format("DD.MM.YYYY HH:mm:ss")
            : ""}
        </td>
        <td>
          {entry.endDate != null
            ? moment.utc(entry.endDate).local().format("DD.MM.YYYY HH:mm:ss")
            : ""}
        </td>
        <td className="center pt-0 pb-0">
          {/* {entry.resultMessage} */}
          <Button
            className="async-jobs-row-button"
            color="primary"
            onClick={() => resultMessage(entry.resultMessage)}
          >
            <div className="async-jobs-row-button-inner-box">
              <FaFile size="1.2em" data-tip data-for="pdf-icon" color="white" />
              Result message
            </div>
          </Button>
        </td>

        {isExport ? (
          <td className="pt-0 pb-0">
            <span
              style={{ gap: 20 }}
              className="d-flex align-items-center justify-content-center"
            >
              {entry.resultDataFileName ? <RenderAction /> : null}
            </span>
          </td>
        ) : null}
      </tr>
      {/* <DeleteAsyncJobModal
        toggle={toggleDelete}
        handleDelete={handleDelete}
        id={entry.id}
        isOpen={isOpenDelete}
      /> */}
    </React.Fragment>
  );
};

export default AsyncJobRow;



// WEBPACK FOOTER //
// ./src/features/organization/pages/async-jobs/async-jobs-table/row/AsyncJobRow.jsx